import React from 'react';
import styled from 'styled-components';
import { colors } from '../../utils/styles';

export const Checkbox = ({ children, className, ...props }) => {
  return (
    <Wrap htmlFor={props.id} className={className}>
      {children}
      <input type="checkbox" {...props} />
      <Checkmark />
    </Wrap>
  );
};

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid rgba(33, 33, 33, 0.3);
  border-radius: 4px;
  transition: 0.2s ease-out all;
  &::after {
    content: '';
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const Wrap = styled.label`
  margin: 0 0 10px;
  display: block;
  position: relative;
  padding-top: 1px;
  padding-left: 30px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  a {
    color: inherit;
  }
  > input {
    position: absolute;
    opacity: 0;
    top: 9px;
    left: 9px;
    cursor: pointer;
    height: 1px;
    width: 1px;
    &:checked ~ ${Checkmark} {
      background: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.primary};
      &::after {
        display: block;
      }
    }
  }
  &:hover {
    ${Checkmark} {
      border-color: ${({ theme }) => theme.primary};
    }
  }
`;
